import {useEffect} from 'react';
import {useProductOptions} from '@shopify/hydrogen';
import PropTypes from 'prop-types';

import {
  ProductActions,
  ProductDescription,
  ProductImageSelector,
  ProductOptionsForm,
} from './index';

import {Accordion} from '~/components/modules/Accordion.client';

import {useParamHelper} from '~/hooks/useParamHelper';
import {sanityMarginToScss} from '~/utils/margins';

export function ProductDetail({sanityProduct, canonicalUrl}) {
  const {selectedOptions} = useProductOptions();
  const {scrubNonManualParams} = useParamHelper();
  useEffect(() => {
    if (typeof localStorage !== 'undefined') {
      const maxLastViewedProducts = 10;
      const currentProductId = sanityProduct?.store?.variants[0]?.store?.sku;
      const lastViewedProducts = JSON.parse(
        localStorage.getItem('lastViewedProducts') || '[]',
      );
      const updatedLastViewed = lastViewedProducts.filter(
        (id) => id !== currentProductId,
      );
      updatedLastViewed.unshift(currentProductId);
      updatedLastViewed.splice(maxLastViewedProducts);
      localStorage.setItem(
        'lastViewedProducts',
        JSON.stringify(updatedLastViewed),
      );
    }
  }, [sanityProduct?.store?.variants[0]?.store?.sku]);

  const params = new URLSearchParams();

  if (Object.keys(selectedOptions).length) {
    // NOTE: this assumes and only works with one option for now
    params.set(
      Object.keys(selectedOptions)[0]?.toLowerCase(),
      Object.values(selectedOptions)[0]?.toLowerCase(),
    );
  }

  return (
    <div className="product-detail">
      <div className="product-detail__images desktop">
        <ProductImageSelector sanityProduct={sanityProduct} />
      </div>
      <div className="product-detail__specs">
        <ProductDescription sanityProduct={sanityProduct} />
        <ProductOptionsForm
          sanityProduct={sanityProduct}
          currentCanonicalUrl={canonicalUrl}
        />
        <ProductActions />
        {sanityProduct?.accordion && (
          <div
            className="featured-accordion"
            style={sanityMarginToScss(sanityProduct.accordion.margins)}
          >
            <Accordion sanityModule={sanityProduct.accordion} />
          </div>
        )}
        <div
          className="product-detail__description"
          dangerouslySetInnerHTML={{
            __html: sanityProduct?.store?.descriptionHtml ?? '',
          }}
        />
      </div>
    </div>
  );
}

ProductDetail.propTypes = {
  sanityProduct: PropTypes.object.isRequired,
};
